// Copyright (c) 2016 Deere & Company

import Claim, {getDefaultState as getClaimDefaultState} from '@deere/cps-it.warranty-model-factory/lib/claim-mass-channel-customer-followup';
import {findMatchingAccount, findMatchingKey} from '../../../shared/services/claim-shared-helper';
import ClaimAction from '@deere/cps-it.warranty-model-factory/lib/claim-action';
import actions from '../../../action-list';
import {getDefaultState} from '../state';

const additionalRepair = (state, action) => {

    const defaultClaim = getClaimDefaultState();

    return Claim.update(defaultClaim, {
        $merge: {
            pin: action.data.pin,
            referenceNumber1: action.data.referenceInfo.referenceNumber1,
            responsibleAccount: action.data.responsibleAccount
        }
    });

};

const addFile = (state, action) =>
    Claim.update(state, {
        file: {
            $push: [action.data]
        }
    });

const copyClaim = state => {

    const defaultClaim = getClaimDefaultState();

    return Claim.update(state, {
        $merge: {
            allowedActions: [
                new ClaimAction({
                    actionName: 'DRAFT',
                    id: 'DRAFT',
                    mode: 'CHG'
                }),
                new ClaimAction({
                    actionName: 'SAVE_VALD',
                    id: 'SAVE_VALD',
                    mode: 'CHG'
                })
            ],
            claimNumber: defaultClaim.claimNumber,
            claimStatus: defaultClaim.claimStatus,
            claimValueDetails: defaultClaim.claimValueDetails,
            errors: defaultClaim.errors,
            recordInfo: defaultClaim.recordInfo,
            reimbursementDetails: defaultClaim.reimbursementDetails
        }
    });

};

const deleteFile = (state, action) => {

    const index = state.file.findIndex(file => file.serialNumber === action.data.serialNumber && file.name === action.data.name);

    return Claim.update(state, {
        file: {
            $splice: [[index, 1]]
        }
    });

};

const updateFile = (state, action) =>
    Claim.update(state, {
        file: {
            $set: action.files
        }
    });

const resetClaim = () => getClaimDefaultState();

const updateClaim = (state, action) =>
    Claim.update(state, {
        $set: action.updatedClaim
    });

const updateQuestions = (state, action) =>
    Claim.update(state, {
        questions: {
            $set: action.questions
        }
    });

const updateContactDate = (state, action) =>
    Claim.update(state, {
        contactDate: {
            $set: action.date
        }
    });

const updateEMail = (state, action) =>
    Claim.update(state, {
        customerDetails: {
            email: {
                $set: action.eMail
            }
        }
    });

const updateFirstName = (state, action) =>
    Claim.update(state, {
        customerDetails: {
            firstName: {
                $set: action.firstName
            }
        }
    });

const updateGoodsInstallationVat = (state, action) =>
    Claim.update(state, {
        goodsInstallationVat: {
            $set: action.goodsInstallationVat
        }
    });

const updateLastName = (state, action) =>
    Claim.update(state, {
        customerDetails: {
            lastName: {
                $set: action.lastName
            }
        }
    });

const updateMethodOfContact = (state, action) =>
    Claim.update(state, {
        methodOfContact: {
            $set: findMatchingKey(action.key, action.options)
        }
    });

const updatePin = (state, action) =>
    Claim.update(state, {
        pin: {
            $set: action.pin
        }
    });

const updateRelationship = (state, action) =>
    Claim.update(state, {
        relationship: {
            $set: findMatchingKey(action.key, action.options)
        }
    });

const updateResponsibleAccount = (state, action) =>
    Claim.update(state, {
        responsibleAccount: {
            $set: findMatchingAccount(action.accountId, action.dealers)
        }
    });

const updateSellingDealer = (state, action) =>
    Claim.update(state, {
        sellingDealer: {
            key: {
                $set: action.key
            },
            value: {
                $set: action.value
            }
        }
    });

const updateWorkOrderOne = (state, action) =>
    Claim.update(state, {
        referenceInfo: {
            referenceNumber1: {
                $set: action.workOrderOne
            }
        }
    });

const updateWorkOrderTwo = (state, action) =>
    Claim.update(state, {
        referenceInfo: {
            referenceNumber2: {
                $set: action.workOrderTwo
            }
        }
    });

const updateClaimQuestionChoice = (state, action) =>
    Claim.update(state, {
        questions: {
            [action.index]: {
                choice: {
                    $set: action.choice
                }
            }
        }
    });

const reviseClaim = state =>
    Claim.update(state, {
        errors: {
            $set: []
        }
    });

export default (state = getDefaultState().claim, action) => {

    const actionTypes = {
        [actions.ADD_CLAIM_MCC_FOLLOWUP_ADDITIONAL_REPAIR]: additionalRepair,
        [actions.ADD_CLAIM_MCC_FOLLOWUP_FILE]: addFile,
        [actions.COPY_CLAIM_MCC_FOLLOWUP]: copyClaim,
        [actions.DELETE_CLAIM_MCC_FOLLOWUP_FILE]: deleteFile,
        [actions.RESET_CLAIM_MCC_FOLLOWUP]: resetClaim,
        [actions.REVISE_CLAIM_MCC_FOLLOWUP]: reviseClaim,
        [actions.SET_CLAIM_MCC_FOLLOWUP]: updateClaim,
        [actions.UPDATE_CLAIM_MCC_FOLLOWUP_CLAIM_QUESTIONS]: updateQuestions,
        [actions.UPDATE_CLAIM_MCC_FOLLOWUP_CONTACT_DATE]: updateContactDate,
        [actions.UPDATE_CLAIM_MCC_FOLLOWUP_E_MAIL]: updateEMail,
        [actions.UPDATE_CLAIM_MCC_FOLLOWUP_FILE]: updateFile,
        [actions.UPDATE_CLAIM_MCC_FOLLOWUP_FIRST_NAME]: updateFirstName,
        [actions.UPDATE_CLAIM_MCC_FOLLOWUP_GOODS_INSTALLATION_VAT]: updateGoodsInstallationVat,
        [actions.UPDATE_CLAIM_MCC_FOLLOWUP_LAST_NAME]: updateLastName,
        [actions.UPDATE_CLAIM_MCC_FOLLOWUP_METHOD_OF_CONTACT]: updateMethodOfContact,
        [actions.UPDATE_CLAIM_MCC_FOLLOWUP_PIN]: updatePin,
        [actions.UPDATE_CLAIM_MCC_FOLLOWUP_QUESTION_CHOICE]: updateClaimQuestionChoice,
        [actions.UPDATE_CLAIM_MCC_FOLLOWUP_RELATIONSHIP]: updateRelationship,
        [actions.UPDATE_CLAIM_MCC_FOLLOWUP_RESPONSIBLE_ACCOUNT]: updateResponsibleAccount,
        [actions.UPDATE_CLAIM_MCC_FOLLOWUP_SELLING_DEALER]: updateSellingDealer,
        [actions.UPDATE_CLAIM_MCC_FOLLOWUP_WORK_ORDER_ONE]: updateWorkOrderOne,
        [actions.UPDATE_CLAIM_MCC_FOLLOWUP_WORK_ORDER_TWO]: updateWorkOrderTwo
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/claim/marketing/mass-channel-customer-followup/reducers/claim.js